import React from "react";
import "./style.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaInstagram } from "react-icons/fa";
import { socialprofils } from "../../content_option";

export const Footer = () => {
  const { i18n } = useTranslation();
  const language = (i18n.language || "en").split("-")[0];
  const isKo = language === "ko";

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-brand">
          <img src="/image/rosota_logo.png" alt="Rosota" className="footer-logo" />
          <p className="footer-tagline">
            {isKo
              ? "현실의 수술을 위한 데이터와 AI의 토대를 만듭니다."
              : "Building the data and AI foundation for real-world surgery."}
          </p>
        </div>

        <nav className="footer-links" aria-label="Footer">
          <span className="footer-col-label">{isKo ? "둘러보기" : "Explore"}</span>
          <Link to="/">{isKo ? "비전" : "Vision"}</Link>
          <Link to="/about">{isKo ? "소개" : "About us"}</Link>
          <Link to="/join">{isKo ? "함께하기" : "Join us"}</Link>
        </nav>

        <div className="footer-contact">
          <span className="footer-col-label">{isKo ? "연결" : "Connect"}</span>
          <div className="footer-social">
            <a href={socialprofils.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>

      <div className="site-footer-bottom">
        <p>© 2026 Rosota. Based in Seoul, South Korea.</p>
      </div>
    </footer>
  );
};

export default Footer;
